import { DataBean } from "../DataBean";

export class AccountantConcept extends DataBean {


    // public async getAccountantConceptCatalog(idAccountantConcept: number | null): Promise<any> {
    //     return this.getCustomService("QuickDataERPCore", "java.util.List_getAccountantConceptCatalog_Number", [idAccountantConcept]);
    // }

    
    public async getAccountantConceptCatalog(processType:any,regexStr:any,idIncomeResponsible: any,idCashFlowConcept:any,factoryName:any,page:any,recordsPerPage:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getAccountantConceptCatalog_Number_String_Number_Number_String_Number_Number", [processType,regexStr,idIncomeResponsible,idCashFlowConcept,factoryName,page,recordsPerPage]);
    }
}